import { Navigate, Outlet } from "react-router-dom";
import { useMe } from "../lib/api";
import { useAuthStore } from "../lib/auth-store";

export function RoleRoute({ roles }: { roles: Array<"user" | "sub_admin" | "admin"> }) {
  const fbUser = useAuthStore((s) => s.fbUser);
  const { data: me, isLoading } = useMe(Boolean(fbUser));

  if (!fbUser) return <Navigate to="/login" replace />;
  if (isLoading) {
    return <div className="mt-20 text-center font-mono text-sm text-cyan-300/70">확인 중…</div>;
  }
  if (!me || !roles.includes(me.role)) return <Navigate to="/" replace />;
  return <Outlet />;
}
